import jsPDF from 'jspdf';

export function gerarRelatorioPDF(resultado, user) {
  const r = resultado;
  const s = r.sintese || {};
  const tipo = r.tipo;
  const doc = new jsPDF('p', 'mm', 'a4');

  const margin = 14;
  let y = margin;

  // ===== CORES SÓBRIAS =====
  const C = {
    primary:   [30, 58, 95],     // Azul escuro profissional
    text:      [33, 37, 41],     // Quase preto
    muted:     [108, 117, 125],  // Cinza médio
    light:     [248, 249, 250],  // Cinza claro fundo
    white:     [255, 255, 255],
    border:    [222, 226, 230],  // Borda sutil
    red:       [185, 28, 28],    // Vermelho sóbrio
    green:     [21, 128, 61],    // Verde sóbrio
    orange:    [194, 65, 12],    // Laranja sóbrio
  };

  const checkNewPage = (needed) => {
    if (y + needed > 280) {
      doc.addPage();
      y = margin;

      // Faixa superior
      doc.setFillColor(...C.primary);
      doc.rect(0, 0, 210, 3, 'F');

      // Header repetido em todas as páginas seguintes
      doc.setFontSize(7);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...C.primary);
      doc.text('ANALISE CENTRAL', margin, 10);

      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...C.muted);
      doc.text(`${user?.empresa || 'Conta autenticada'} | WhatsApp: ${user?.whatsapp || '-'}`, margin, 14);

      doc.setDrawColor(...C.border);
      doc.line(margin, 16, 195, 16);

      y = 22;
    }
  };

  const txt = (text, x, yy, opts = {}) => {
    doc.setFontSize(opts.size || 10);
    doc.setFont('helvetica', opts.bold ? 'bold' : 'normal');
    doc.setTextColor(...(opts.color || C.text));
    doc.text(String(text), x, yy, { maxWidth: opts.maxW || 180 });
    return yy + (opts.h || 5);
  };

  const sectionTitle = (title) => {
    checkNewPage(14);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...C.primary);
    doc.text(title.toUpperCase(), margin, y + 5);
    doc.setDrawColor(...C.primary);
    doc.setLineWidth(0.4);
    doc.line(margin, y + 7, margin + 50, y + 7);
    doc.setLineWidth(0.2);
    y += 12;
    doc.setTextColor(...C.text);
  };

  const card = (idx, lines, opts = {}) => {
    const lineH = 5;
    const pad = 8;
    const h = lines.length * lineH + pad + 5;
    checkNewPage(h + 5);

    doc.setDrawColor(...C.border);
    doc.setFillColor(...C.white);
    doc.roundedRect(margin, y, 180, h, 2, 2, 'FD');

    // Faixa lateral sutil
    const stripe = opts.stripe || C.primary;
    doc.setFillColor(...stripe);
    doc.rect(margin, y, 2.5, h, 'F');

    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...C.muted);
    doc.text(`#${idx + 1}`, margin + 6, y + 5);

    let ly = y + 10;
    lines.forEach(line => {
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...C.text);
      doc.text(String(line), margin + 6, ly, { maxWidth: 170 });
      ly += lineH;
    });

    y += h + 4;
  };

  const table = (headers, rows) => {
    if (!rows?.length) {
      y = txt('Nenhum registro encontrado.', margin + 2, y, { size: 9, color: C.muted });
      y += 4;
      return;
    }

    const idxWidth = 12;           // largura fixa da coluna #
    const totalW = 180;
    const dataW = totalW - idxWidth;
    const dataCols = headers.length - 1;
    const colW = dataW / dataCols; // largura das demais colunas
    const rowH = 6;
    const headH = 8;
    const totalH = headH + rows.length * rowH + 4;
    checkNewPage(totalH);

    // Cabeçalho
    doc.setFillColor(...C.primary);
    doc.rect(margin, y, totalW, headH, 'F');
    doc.setTextColor(...C.white);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');

    headers.forEach((h, i) => {
      const x = margin + 3 + (i === 0 ? 0 : idxWidth + (i - 1) * colW);
      doc.text(String(h), x, y + 5.5);
    });
    y += headH;

    // Linhas
    rows.forEach((row, ri) => {
      if (ri % 2 === 0) {
        doc.setFillColor(...C.light);
        doc.rect(margin, y, totalW, rowH, 'F');
      }
      doc.setTextColor(...C.text);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');

      row.forEach((cell, ci) => {
        const x = margin + 3 + (ci === 0 ? 0 : idxWidth + (ci - 1) * colW);
        const maxW = ci === 0 ? idxWidth - 5 : colW - 5;
        doc.text(String(cell || '-'), x, y + 4.5, { maxWidth: maxW });
      });
      y += rowH;
    });

    y += 5;
  };

  const info2Col = (items) => {
    checkNewPage(Math.ceil(items.length / 2) * 9 + 2);
    items.forEach(([label, value], i) => {
      const colX = i % 2 === 0 ? margin + 2 : 105;
      const rowOffset = Math.floor(i / 2) * 9;
      if (i % 2 === 0) checkNewPage(9);

      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...C.muted);
      doc.text(String(label), colX, y + rowOffset);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...C.text);
      doc.text(String(value || '-'), colX, y + rowOffset + 4, { maxWidth: 90 });
    });
    y += Math.ceil(items.length / 2) * 9 + 2;
  };

  // ===== HEADER PRIMEIRA PÁGINA =====
  doc.setFillColor(...C.primary);
  doc.rect(0, 0, 210, 42, 'F');
  doc.setTextColor(...C.white);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('Analise Central', margin, 16);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Relatorio de Consulta', margin, 24);
  doc.text(`Empresa: ${user?.empresa || 'Conta autenticada'}`, margin, 30);
  doc.text(`WhatsApp: ${user?.whatsapp || '-'}`, margin, 35);
  doc.text(`Data: ${r.dataConsulta} | ${tipo === 'PF' ? 'Pessoa Fisica' : 'Pessoa Juridica'}`, margin, 40);
  y = 48;

  // ===== DADOS PRINCIPAIS =====
  sectionTitle(tipo === 'PF' ? 'Dados Pessoais' : 'Dados da Empresa');

  if (tipo === 'PF') {
    info2Col([
      ['Nome', r.pessoa.nome],
      ['CPF', r.pessoa.cpf],
      ['Regiao', s.pessoa?.[0]?.regiao_cpf],
      ['Idade', `${r.pessoa.idade} anos`],
      ['Nascimento', r.pessoa.dataNascimento],
      ['Genero', r.pessoa.genero],
      ['Mae', r.pessoa.mae],
      ['Perfil', r.pessoa.mosaic],
    ]);
  } else {
    info2Col([
      ['Razao Social', r.pessoa.razaoSocial],
      ['Fantasia', r.pessoa.nomeFantasia],
      ['CNPJ', r.pessoa.cnpj],
      ['Capital', r.pessoa.capitalSocial],
      ['Tipo', r.pessoa.tipoEstabelecimento],
      ['Natureza', r.pessoa.naturezaJuridica],
      ['Fundacao', r.pessoa.dataFundacao],
      ['Situacao', r.pessoa.situacaoCnpj],
    ]);
  }

  // ===== ALERTAS =====
  sectionTitle('Pontos de Atencao');
  if (r.alertas?.length) {
    r.alertas.forEach(item => {
      checkNewPage(8);
      y = txt(`- ${item}`, margin + 2, y, { size: 9, color: C.red });
    });
  } else {
    y = txt('Nenhum ponto de atencao.', margin + 2, y, { size: 9, color: C.muted });
  }
  y += 3;

  // ===== POSITIVOS =====
  sectionTitle('Fatores Positivos');
  if (r.positivos?.length) {
    r.positivos.forEach(item => {
      checkNewPage(8);
      y = txt(`+ ${item}`, margin + 2, y, { size: 9, color: C.green });
    });
  } else {
    y = txt('Nenhum fator positivo.', margin + 2, y, { size: 9, color: C.muted });
  }
  y += 3;

  // ===== TABELAS =====
  sectionTitle('CPF na Receita Federal');
  table(['#', 'CPF', 'Situacao', 'Codigo da Receita'],
    (s.pessoa || []).map((p, i) => [i + 1, p.cpf, p.situacao_cpf, p.codigo_controle_receita_federal]));

  sectionTitle('Telefones Vinculados');
  table(['#', 'Telefone', 'Tipo', 'Prioridade', 'Categoria'],
    (s.telefones || []).map((t, i) => [i + 1, t.telefone_completo || `(${t.ddd}) ${t.telefone}`, t.tipo_telefone, t.prioridade, t.categoria]));

  sectionTitle('Emails Vinculados');
  table(['#', 'Email', 'Tipo', 'Prioridade', 'Categoria'],
    (s.emails || []).map((e, i) => [i + 1, e.email, e.tipo_email, e.prioridade, e.categoria]));

  // ===== ENDEREÇOS =====
  sectionTitle('Enderecos');
  if (s.enderecos?.length) {
    s.enderecos.forEach((e, i) => {
      const log = `${e.tipo_logradouro ? e.tipo_logradouro + ' ' : ''}${e.logradouro}${e.numero ? ', ' + e.numero : ''}${e.complemento ? ' - ' + e.complemento : ''}`;
      card(i, [
        `Logradouro: ${log}`,
        `Bairro: ${e.bairro || '-'}`,
        `Municipio/UF: ${e.municipio || '-'} / ${e.uf || '-'}`,
        `CEP: ${e.cep || '-'}`,
        `Categoria: ${e.categoria || '-'} | Prioridade: ${e.prioridade || '-'}`,
      ]);
    });
  } else {
    y = txt('Nenhum endereco encontrado.', margin + 2, y, { size: 9, color: C.muted });
  }

  // ===== OCUPAÇÕES =====
  if (tipo === 'PF') {
    sectionTitle('Atividades Ocupacionais');
    if (s.ocupacoes?.length) {
      s.ocupacoes.forEach((o, i) => card(i, [
        `Grupo: ${o.grupo || '-'}`,
        `CBO: ${o.cbo || '-'}`,
        `Descricao: ${o.descricao || '-'}`,
      ]));
    } else {
      y = txt('Nenhuma atividade ocupacional encontrada.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== ATIVIDADES ECONÔMICAS =====
  if (tipo === 'PJ') {
    sectionTitle('Atividades Economicas');
    if (s.atividade_economica?.length) {
      s.atividade_economica.forEach((e, i) => card(i, [
        `CNAE: ${e.cnae || '-'}`,
        `Descricao: ${e.descricao || '-'}`,
        `Tipo: ${e.tipo_atividade || '-'}`,
      ]));
    } else {
      y = txt('Nenhuma atividade economica encontrada.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== VÍNCULOS =====
  if (tipo === 'PF') {
    sectionTitle('Vinculos Empregaticios');
    if (s.vinculos_empresas?.length) {
      s.vinculos_empresas.forEach((v, i) => {
        const lines = [
          `Razao Social: ${v.razao_social || '-'}`,
          `CNPJ: ${v.cnpj_vinculo || '-'}`,
          `Tipo: ${v.tipo_relacao || '-'}`,
          `Situacao: ${v.situacao_cadastral || '-'}`,
          `Fundacao: ${v.data_fundacao || '-'}${v.anos_fundacao ? ` (${v.anos_fundacao} anos)` : ''}`,
        ];
        if (v.nome_fantasia) lines.splice(1, 0, `Fantasia: ${v.nome_fantasia}`);
        if (v.setor_atividade) lines.push(`Setor: ${v.setor_atividade}`);
        card(i, lines);
      });
    } else {
      y = txt('Nenhum vinculo empregaticio encontrado.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== SOCIEDADES =====
  if (tipo === 'PF') {
    sectionTitle('Sociedades');
    if (s.socios?.length) {
      s.socios.forEach((soc, i) => {
        const lines = [
          `Nome: ${soc.nome || '-'}`,
          `Razao Social: ${soc.razao_social || '-'}`,
          `CNPJ: ${soc.cnpj || '-'}`,
          `CPF: ${soc.cpf || '-'}`,
          `Idade: ${soc.idade || '-'}`,
          `Nascimento: ${soc.data_nascimento || '-'}`,
        ];
        if (soc.mandado_prisao === 'CONSTA OCORRENCIA') lines.push('ATENCAO: CONSTA OCORRENCIA');
        card(i, lines, { stripe: C.orange });
      });
    } else {
      y = txt('Nenhuma sociedade encontrada.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== PARTICIPAÇÕES =====
  if (tipo === 'PF') {
    sectionTitle('Participacoes');
    if (s.participacoes?.length) {
      s.participacoes.forEach((p, i) => {
        const lines = [
          `Razao Social: ${p.razao_social || '-'}`,
          `CNPJ: ${p.cnpj || '-'}`,
          `Setor: ${p.setor_atividade || '-'}`,
          `Territorio: ${p.territorio || '-'}, ${p.pais || '-'}`,
          `Anos Fundacao: ${p.anos_fundacao || '-'}`,
          `Data Fundacao: ${p.data_fundacao || '-'}`,
          `Data Entrada: ${p.data_entrada_sociedade || '-'}`,
        ];
        if (p.mandado_prisao === 'CONSTA OCORRENCIA') lines.push('ATENCAO: CONSTA OCORRENCIA');
        card(i, lines, { stripe: C.orange });
      });
    } else {
      y = txt('Nenhuma participacao encontrada.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== SÓCIOS PJ =====
  if (tipo === 'PJ') {
    sectionTitle('Socios Pessoa Fisica');
    if (s.qsa_pf?.length) {
      s.qsa_pf.forEach((soc, i) => card(i, [
        `Nome: ${soc.nome_socio || '-'}`,
        `CPF: ${soc.cpf_socio || '-'}`,
      ]));
    } else {
      y = txt('Nenhum socio pessoa fisica encontrado.', margin + 2, y, { size: 9, color: C.muted });
    }

    sectionTitle('Socios Pessoa Juridica');
    if (s.qsa_pj?.length) {
      s.qsa_pj.forEach((soc, i) => card(i, [
        `Razao Social: ${soc.razao_social || '-'}`,
        `CNPJ: ${soc.cnpj_socio || '-'}`,
      ]));
    } else {
      y = txt('Nenhum socio pessoa juridica encontrado.', margin + 2, y, { size: 9, color: C.muted });
    }

    sectionTitle('Socios Estrangeiros');
    if (s.qsa_estrangeiro?.length) {
      s.qsa_estrangeiro.forEach((soc, i) => card(i, [
        `Representante: ${soc.nome_representante_legal || '-'}`,
        `CPF Representante: ${soc.cpf_representante_legal || '-'}`,
      ]));
    } else {
      y = txt('Nenhum socio estrangeiro encontrado.', margin + 2, y, { size: 9, color: C.muted });
    }
  }

  // ===== PEP =====
  sectionTitle('Pessoa Politicamente Exposta');
  if (s.pep?.length) {
    s.pep.forEach((p, i) => card(i, [
      `Funcao: ${p.sigla_funcao || '-'} - ${p.descricao_funcao || '-'}`,
      `Nivel: ${p.nivel_funcao || '-'}`,
      `Orgao: ${p.nome_orgao || '-'}`,
      `Inicio: ${p.data_inicio_exercicio || '-'}`,
      `Fim: ${p.data_fim_exercicio || '-'}`,
      `Fim Carencia: ${p.data_fim_carencia || '-'}`,
    ]));
  } else {
    y = txt('Nenhuma pessoa politicamente exposta encontrada.', margin + 2, y, { size: 9, color: C.muted });
  }

  // ===== MANDADOS =====
  sectionTitle('Mandados de Prisao');
  if (s.mandados_prisao?.length) {
    s.mandados_prisao.forEach((m, i) => card(i, [
      `Numero: ${m.numero || '-'}`,
      `Alcunha: ${m.alcunha || '-'}`,
      `Peca: ${m.peca || '-'}`,
      `Situacao: ${m.situacao || '-'}`,
      `Data Expedicao: ${m.data_expedicao || '-'}`,
      `Orgao Expedidor: ${m.orgao_expedidor || '-'}`,
    ], { stripe: C.red }));
  } else {
    y = txt('Nenhum mandado de prisao encontrado.', margin + 2, y, { size: 9, color: C.muted });
  }

  // ===== FOOTER =====
  checkNewPage(18);
  doc.setDrawColor(...C.primary);
  doc.line(margin, y, 195, y);
  y += 5;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...C.primary);
  doc.text('ANALISE CENTRAL', margin, y);
  y += 4;
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...C.muted);
  doc.text(`Relatorio gerado em ${new Date().toLocaleString('pt-BR')} v1.0`, margin, y);
  y += 4;
  doc.setFontSize(7);
  doc.text('Este documento e confidencial e destinado exclusivamente ao titular da conta.', margin, y);

  // Paginacao
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(...C.muted);
    doc.text(`${i} / ${totalPages}`, 195, 290, { align: 'right' });
  }

  // ===== SALVAR / DOWNLOAD (CROSS-PLATFORM) =====
  const nome = tipo === 'PF'
    ? `relatorio_${r.pessoa.cpf.replace(/\D/g, '')}.pdf`
    : `relatorio_${r.pessoa.cnpj.replace(/\D/g, '')}.pdf`;

  const pdfBlob = doc.output('blob');
  const url = URL.createObjectURL(pdfBlob);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  if (isIOS) {
    window.location.href = url;
    setTimeout(() => {
      alert('📱 Toque em "Compartilhar" (□↑) e depois "Salvar em Arquivos" para guardar o PDF.');
    }, 500);
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  setTimeout(() => URL.revokeObjectURL(url), 2000);
}